import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const FILE_BASE = BACKEND_URL; // for relative /api/files/... URLs

export const api = axios.create({ baseURL: API_BASE });

// Attach token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const resolveFileUrl = (url) => {
  if (!url) return undefined;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/files/")) return `${BACKEND_URL}${url}`;
  return url;
};

// Turn a mixtape/single/whatever into a queue for the global MediaPlayer.
// Multi-track mixtapes (`tracks: [{title,url}]`) unroll into one queue entry
// per track so the player auto-advances. Single-file releases fall back to
// the legacy shape.
export const contentToQueue = (item, ctype = "mixtapes") => {
  if (!item) return [];
  const tracks = Array.isArray(item.tracks) ? item.tracks.filter((t) => t?.url) : [];
  if (tracks.length > 0) {
    return tracks.map((t, i) => ({
      id: `${item.id}:${i}`,
      title: t.title || `${item.title} · Track ${i + 1}`,
      artist: item.artist,
      cover: item.cover_image,
      url: t.url,
      ctype,
    }));
  }
  if (!item.file_url) return [];
  return [{
    id: item.id,
    title: item.title,
    artist: item.artist,
    cover: item.cover_image,
    url: item.file_url,
    ctype,
  }];
};

// Social share + promo helpers (server renders OG tags / branded images)
const shareBase = () =>
  (process.env.REACT_APP_CANONICAL_URL || window.location.origin).replace(/\/$/, "");

export const shareUrl = (ctype, id) => `${shareBase()}/api/share/${ctype}/${id}`;

export const promoUrl = (ctype, id, fmt, download = false) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/promo/${ctype}/${id}/${fmt}.jpg${download ? "?download=1" : ""}`;
